import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KpiGroupComponent } from './kpi-group/kpi-group.component';
import { KpiGroupService } from './kpi-group.service';
import { InfoPopoverModule } from '../info-popover/info-popover.module';

@NgModule({
  imports: [
    CommonModule,
    InfoPopoverModule
  ],
  declarations: [KpiGroupComponent],
  providers: [KpiGroupService],
  exports: [KpiGroupComponent]
})
export class KpiGroupModule { }
